import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import store from "./store";
import { QueryClientProvider } from "./config/QuaryClient";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider>
        <App />
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);
